"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapReportComponentType = mapReportComponentType;
const sonar_ts_constants_1 = require("@sonar-software/sonar-ts-constants");
const reportComponentTypeMap = {
    aggregateColumn: sonar_ts_constants_1.REPORT_COMPONENT_TYPES.AGGREGATE_COLUMN,
    column: sonar_ts_constants_1.REPORT_COMPONENT_TYPES.COLUMN,
    crossFilter: sonar_ts_constants_1.REPORT_COMPONENT_TYPES.CROSS_FILTER,
    crossFilterCriterion: sonar_ts_constants_1.REPORT_COMPONENT_TYPES.CROSS_FILTER_CRITERIA,
    customDetailFormula: sonar_ts_constants_1.REPORT_COMPONENT_TYPES.CUSTOM_DETAIL_FORMULA,
    customSummaryFormula: sonar_ts_constants_1.REPORT_COMPONENT_TYPES.CUSTOM_SUMMARY_FORMULA,
    filter: sonar_ts_constants_1.REPORT_COMPONENT_TYPES.FILTER,
    grouping: sonar_ts_constants_1.REPORT_COMPONENT_TYPES.GROUPING
};
function mapReportComponentType(componentType) {
    var _a;
    if (!componentType) {
        return componentType;
    }
    return (_a = reportComponentTypeMap[componentType]) !== null && _a !== void 0 ? _a : componentType;
}
//# sourceMappingURL=lib.js.map